import { apiFetchJson } from "./apiClient";
import { FateFormula, FateFormulaRequest } from "../types/types";

const enc = (s?: string) => (s ? `?search=${encodeURIComponent(s)}` : "");

export class FateFormulaService {
  static listUser(search?: string): Promise<FateFormula[]> {
    return apiFetchJson(`/api/protected/fate-formulas${enc(search)}`);
  }
  static createUser(req: FateFormulaRequest): Promise<FateFormula> {
    return apiFetchJson(`/api/protected/fate-formulas`, {
      method: "POST",
      body: JSON.stringify(req),
    });
  }
  static updateUser(id: number, req: FateFormulaRequest): Promise<FateFormula> {
    return apiFetchJson(`/api/protected/fate-formulas/${id}`, {
      method: "PUT",
      body: JSON.stringify(req),
    });
  }
  static deleteUser(id: number): Promise<{ message: string }> {
    return apiFetchJson(`/api/protected/fate-formulas/${id}`, { method: "DELETE" });
  }
  static listCampaign(campaignId: number, search?: string): Promise<FateFormula[]> {
    return apiFetchJson(`/api/protected/campaigns/${campaignId}/fate-formulas${enc(search)}`);
  }
  static createCampaign(campaignId: number, req: FateFormulaRequest): Promise<FateFormula> {
    return apiFetchJson(`/api/protected/campaigns/${campaignId}/fate-formulas`, {
      method: "POST",
      body: JSON.stringify(req),
    });
  }
  static updateCampaign(
    campaignId: number,
    id: number,
    req: FateFormulaRequest
  ): Promise<FateFormula> {
    return apiFetchJson(`/api/protected/campaigns/${campaignId}/fate-formulas/${id}`, {
      method: "PUT",
      body: JSON.stringify(req),
    });
  }
  static deleteCampaign(campaignId: number, id: number): Promise<{ message: string }> {
    return apiFetchJson(`/api/protected/campaigns/${campaignId}/fate-formulas/${id}`, {
      method: "DELETE",
    });
  }
}
